import func from "./func";
const dapingChart = {
    // 2019-05-16 2019-05-16 lxl  天正传感器分类
    tzSensorCatId: '20181217151828yraPJcuH',
    myColor: ['#66AEDE', '#f391a9', '#faa755', '#45b97c'],
    startAngle: 205, //  总共剩余分配300度，3

    getChartOption2(titleText, sensorType, value,union){
      var  option = {
            tooltip: {
                formatter: '{a} <br/>{c} {b}'
            },
          // 隐藏工具箱
            toolbox: {
                show: false,
                feature: {
                    mark: {show: true},
                    restore: {show: true},
                    saveAsImage: {show: true}
                }
            },
            series: [
                {
                    name: titleText,
                    type: 'gauge',
                    min: 0,
                    animation:false,
                    splitNumber: 5,
                    max: this.getMaxValue(sensorType),
                    radius: '90%',  // 外半径
                    axisLine: {            // 坐标轴线
                        lineStyle: {       // 属性lineStyle控制线条样式
                            color: [[0.09, 'lime'], [0.82, '#1e90ff'], [1, '#ff4500']],
                            width: 3,
                            shadowBlur: 10
                        }
                    },
                    axisLabel: {            // 坐标轴小标记
                        fontWeight: 'bolder',
                        color: '#fff',
                        shadowBlur: 10
                    },
                    axisTick: {            // 坐标轴小标记
                        length: 13,        // 属性length控制线长
                        lineStyle: {       // 属性lineStyle控制线条样式
                            color: 'auto',
                            shadowBlur: 10
                        }
                    },
                    splitLine: {           // 分隔线
                        length: 18,         // 属性length控制线长
                        lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                            width: 3,
                            color: '#fff',
                            shadowColor: '#fff', //默认透明
                            shadowBlur: 10
                        }
                    },
                    pointer: {           // 分隔线
                        shadowColor: '#fff', //默认透明
                        shadowBlur: 5
                    },
                    title: {// 数值单位
                        textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                            fontWeight: 'bolder',
                            fontSize: 10,
                            fontStyle: 'italic',
                            color: '#fff',
                            shadowColor: '#fff', //默认透明
                            shadowBlur: 10
                        }
                    },
                    detail: {  // 方框具体数值
                        borderWidth: 0,// 取消方框
                        borderColor: '#fff',
                        shadowColor: '#fff', //默认透明
                        shadowBlur: 5,
                        offsetCenter: [0, '65%'],       // x, y，单位px
                        textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                            fontWeight: 'bolder',
                            color: '#cee'
                        }
                    },
                    data: [{value: value, name: union}]
                }
            ]

        };
     /*   setInterval(function (){
            option.series[0].data[0].value = (Math.random()*100).toFixed(2) - 0;
            option.series[1].data[0].value = (Math.random()*7).toFixed(2) - 0;
            option.series[2].data[0].value = (Math.random()*2).toFixed(2) - 0;
            option.series[3].data[0].value = (Math.random()*2).toFixed(2) - 0;
            myChart.setOption(option);
        },2000);*/
        return option;
    },
    getChartOption(titleText, sensorType, value,union){
        console.log(sensorType)
        var xsValue=value+"("+union+")";
        if(union=="暂无数据"){
            xsValue="暂无数据";
        }
        var placeHolderStyle = {
            normal: {
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                },
                color: "rgba(0,0,0,0)",
                borderWidth: 0
            },
            emphasis: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0
            }
        };

        var dataStyle = {
            normal: {
                formatter: '{c}',
                position: 'center',
                show: true,
                textStyle: {
                    fontSize: '18',
                    fontWeight: 'bold',
                    color: '#fff'
                }
            }
        };

        var option = {
            title: [{
                text:xsValue,
                left: '48%',
                top: '48%',
                textAlign: 'center',
                textStyle: {
                    fontWeight: 'bold',
                    fontSize: '9',
                    color: '#fff',
                    textAlign: 'center',
                },
            }],

            //第一个图表 底层背景环
            series: [{
                type: 'pie',
                hoverAnimation: true, //鼠标经过的特效
                radius: ['65%', '90%'],
                center: ['50%', '50%'],
                startAngle: this.startAngle,
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                label: {
                    normal: {
                        position: 'center'
                    }
                },
                data: [{
                    value: 270,
                    itemStyle: {
                        normal: {
                            color: "rgba(30,144,200,0.3)",
                            borderWidth: 1,
                            borderColor:"#1E90F0"
                        }
                    },
                }, {
                    value: 150,  // 使用：填充环 = 3:1
                    itemStyle: placeHolderStyle,
                },

                ]
            },
                //上层环形配置  主要显示
                {
                    type: 'pie',
                    hoverAnimation: false, //鼠标经过的特效
                    radius: ['65%', '90%'],
                    center: ['50%', '50%'],
                    startAngle: this.startAngle,
                    labelLine: {
                        normal: {
                            show: true
                        }
                    },
                    label: {
                        normal: {
                            position: 'center'
                        }
                    },
                    data: [{
                        value: value,
                        itemStyle: {
                            normal: {
                                color: '#FF8C00'
                            }
                        },
                        label: dataStyle,
                    }, {
                        value: this.getEmpty(value,sensorType),
                        itemStyle: placeHolderStyle,
                    },

                    ]
                }

            ]

        }

        return option;

    },

    getView3Chart(){
      var  option = {
            title: {
                text: '堆叠区域图'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: [120, 132, 101, 134, 90, 230, 210]
                },
                {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: [220, 182, 191, 234, 290, 330, 310]
                },
                {
                    name: '视频广告',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: [150, 232, 201, 154, 190, 330, 410]
                },
                {
                    name: '直接访问',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: [320, 332, 301, 334, 390, 330, 320]
                },
                {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    areaStyle: {},
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }
            ]
        };

    },
    getEmpty(value,sensorType){
        var temp = (360 - (parseFloat(value * 270) / this.getMaxValue(sensorType))) * this.getMaxValue(sensorType) / 270;
        console.log("剩余值为:" + temp)
        return temp;
    },
    getMaxValue(sensorType){
        console.log("传感器的数据类型" + sensorType)
        var maxValue;
        switch (sensorType) {
            case 'sw':
                maxValue = 50;
                break;
            case 'hw':
                maxValue = 1;
                break;
            case 'gzd':
                maxValue = 65535;
                break;
            case 'zs':
                maxValue = 130;
                break;
            case 'ws':
            case 'dpws':
            case 'trws':
                maxValue = 100;
                break;
            case 'pm2510':
                maxValue = 1000;
                break;
            case 'CO2':
                maxValue = 100;
                break;
            case 'O2':
                maxValue = 100;
                break;
            case 'dqy':
                maxValue = 1200;
                break;
            case 'kqzl':
                maxValue = 1000; // TVOC
                break;
            case 'yl':
                maxValue = 30;
                break;
            case 'rjy':
                maxValue = 20;
                break;
            case 'ph':
                maxValue = 14;
                break;
            case 'ad':
                maxValue = 100;
                break;
            case 'trsd':
                maxValue = 100;
                break;
            case 'swen':
                maxValue = 100;
                break;
            case 'ddl':
                maxValue = 2000;
                break;
            default:
                maxValue = 100;
                break;
        }
        return maxValue;
    },
    getDate(timesnap){
        var date = new Date(timesnap);
        return tzUtil.format2(date.getMonth() + 1)
            + '-' + tzUtil.format2(date.getDate()) + ' '
            + tzUtil.format2(date.getHours()) + ':'
            + tzUtil.format2(date.getMinutes());
    },

    /**
     * 补零
     * @param val
     * @returns {*}
     */
    format2(val){
        if (val < 10) {
            val = '0' + val
        }
        return val
    },
}
export default dapingChart;

